const state = {
  list: [],
  loading: false,
};

const mutations = {
  setList (state, data) {
    state.list = data;
  },
  setLoading (state, value) {
    state.loading = value;
  },
};

const actions = {
  async fetchList ({commit}, apiPlugin) {
    commit('setLoading', true);
    try {
      const res = await apiPlugin.post(['inventory'], {});
      commit('setList', res.data.page || []);
    } finally {
      commit('setLoading', false);
    }
  },
};

const getters = {
  list: state => state.list,
  loading: state => state.loading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
